<template>
  <div class="list-modal h-card shadow">
    <div class="card-header">
      <div class="modal-title">Перенос брони</div>
      <button type="button" @click="closeCmodal" class="btn-close" data-bs-dismiss="modal"
              aria-label="Закрыть"></button>
    </div>
    <div v-if="loading">
      <div class="px-1 py-4 p-sm-4 my-3 d-flex flex-row justify-content-center">
        <div>
          <span class="spinner-border spinner-border-sm text-primary me-2"></span>
        </div>
        <div>
          Подождите...
        </div>
      </div>
    </div>
    <div class="card-body"  v-if="!loading">
      <div class="p-3 small">
        <p>Вы можете перенести текущие брони в другой кабинет в этом же центре.</p>
        <div>
          <h6>{{ cabinetData.title }}</h6>
          <div>Дата: {{ dateFormat }}</div>
        </div>
        Выберите необходимое время для переноса:
      </div>

      <div class="d-flex flex-column  px-3 h-100">
        <div class="overflow-auto">
          <div class="d-flex flex-row gap-1" id="timecheck">
            <template v-for="(bData, index) in bookingMatrix" :key="bData.id">
              <div v-if="index && isViewGap(bData.totalMinutes)">
                <div class="block-gap">
                  ...
                </div>
              </div>

              <div class="block-line">
                <div class="form-check d-flex flex-column gap-2 align-items-center">
                  <input class="form-check-input" @change="handleSelection(bData.id)" type="checkbox" :value="bData.id"
                         v-model="selectedIds" :id="bData.id"  :disabled="disabledCheckboxesSelect.includes(bData.id)" >
                  <label class="form-check-label" :for="bData.id">
                    <span class="hourBlock" :class="isErrorBlock(bData.id)">
                      <span class="block">{{ timeView1(bData) }}</span>
                      -
                      <span class="block">{{ timeView2(bData) }}</span>
                    </span>
                  </label>
                </div>
              </div>
              {{ setTimeViewTotalMinutes(bData.totalMinutes) }}
            </template>
          </div>
        </div>
        <div class="error-msg-block mt-3" v-if="validationMessage.length">
          <div >
            <template v-for="(errorMsg, index) in validationMessage" :key="index">
              <div>{{ errorMsg }}</div>
            </template>
          </div>
        </div>
        <div v-show="searchOn">
          <div class="mt-3 mb-3 small">
            <div>Ниже показаны слоты, в которые можно перенести текущую бронь.</div>
            <div class="fw-bold">Выберите нужные и нажмите кнопку "Перенести брони".</div>
          </div>
        </div>
        <div class="overflow-auto" style="height: 50vh;">
          <div v-show="searchOn">
          <template v-for="(cabData, cabinet_id) in loadedData.cabinetsData.cabinetsInfo[this.searchData.officeId]" :key="cabinet_id">

            <div class="small fw-bolder" v-if="cabinet_id != cabinetData.cabinet_id">{{cabData.title}}</div>
            <div v-if="cabinet_id != cabinetData.cabinet_id" class="card-line overflow-auto mb-3 p-2">
                <div v-if="!isCountData(cabinet_id)" class="small text-muted">
                  Нет свободного времени для бронирования
                </div>

                <div class="d-flex flex-row gap-1" >
                  <template v-for="(slot, indexSlot) in cabinetMatrix[cabinet_id]" :key="indexSlot">

                    <div v-if="isViewGapCabinet(slot.fullTime)">
                      <div class="block-gap cabinet">
                        ...
                      </div>
                    </div>


                      <div class="block-line">
                        <div class="form-check d-flex flex-column gap-2 align-items-center" @click="selectMove(slot.id)">

                          <div class="text-center">
                            <span :class="{'fake-checkbox':true,'checked':selectMoveIds.includes(slot.id),'hide':hideSelectMove(slot.id)}"  ></span>
                          </div>

                          <label class="form-check-label">
                          <span class="hourBlock">
                            <span class="block">{{ slot.timeStart }}</span>
                            -
                            <span class="block">{{ slot.timeEnd }}</span>
                          </span>
                          </label>
                        </div>
                        <div class="price-lbl">{{ slot.price }} ₽</div>
                      </div>
                    {{ setTimeViewTotalMinutesCabinet(slot.fullTime) }}
                  </template>
                  {{setTimeViewTotalMinutesCabinetReset()}}
                </div>

            </div>

          </template>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer d-flex align-items-center">
      <span v-show="loaderShow" class="spinner-border spinner-border-sm text-primary me-3"></span>
      <button v-show="!loaderShow && selectMoveIds.length" class="close-btn me-1" @click="resetSelect">Сбросить</button>
      <button class="ok-btn me-1" @click="moveBooking" :disabled="btnDisabled">Перенести брони</button>
      <button class="close-btn" @click="closeCmodal">Закрыть</button>
    </div>


  </div>
</template>
<script>
import {closeModal} from "jenesius-vue-modal";
import {dateFormat} from "@/dateFormat";
// eslint-disable-next-line no-unused-vars
import {API} from "@/getapi";
import {useToast} from "vue-toastification";

let lastViewTotalMinutes = -1;
let lastViewTotalMinutesCabinet = -1;
export default {
  name: 'MoveBookingsModalList',
  inject: [
    'URL_CHANGE_BOOKINGS', 'URL_GET'
  ],
  props: {
    bookingData: Object,
    cabinetData: Object,
    date: String
  },
  data() {
    return {
      restext: '',
      errorBlock: [],
      bookingMatrix: [],
      bookingLinkIdToMinutes: {},
      currentBookingId: false,
      selectMoveIds:[],
      selectedIds: [], // Список выбранных для отмены ID
      changeSelectedIds: [], //
      disabledCheckboxesSelect:[],
      disabledCheckboxes:{},
      selectedLinkIds: {}, // Список связей переноса
      validationMessage: "",
      timeLineIndex: [],
      loaderShow: false,
      btnDisabled: true,
      loading: true,
      workTimeStart:'',
      workTimeEnd:'',
      searchOn: false,
      searchData: {
        'officeId': 0,
        'date': "",
        'capacity': 0,
        'metro': 0,
        'price_start': 0,
        'price_end': 15000,
        'time_to': 0,
        'time_from': 0,
      },
      loadedData:{},
      cabinetMatrix:{}
    }
  },
  setup() {
    // Get toast interface
    const toast = useToast();
    return {toast}
  },
  mounted() {

    // for (let index in this.bookingMatrix){
    //   let checkBoxId = this.bookingMatrix[index]['id']
    //   this.disabledCheckboxes[checkBoxId] = false;
    // }

    this.searchData.officeId = this.cabinetData.office_id;
    this.searchData.date = this.date;
    // this.buildTimeLineIndex()
    this.biuldMatrix()
    this.getOfficeData()

  },
  computed: {
    dateFormat() {
      return dateFormat.strToFormat(this.date)
    },
    // timeLineData(){
    //   const startHour = Number(this.workTimeStart.split(":")[0])
    //   const startMinute = Number(this.workTimeStart.split(":")[1])
    //   const endHour = Number(this.workTimeEnd.split(":")[0])
    //   const endMinute = Number(this.workTimeEnd.split(":")[1])
    //   const startTime = startHour * 60 + startMinute; // 8:30 в минутах
    //   const endTime = endHour * 60 + endMinute; // 22:00 в минутах
    //   const interval = 30; // Интервал в минутах
    //
    //   let slots = [];
    //   for (let time = startTime; time < endTime; time += interval) {
    //     const start = this.formatTime(time);
    //     const end = this.formatTime(time + interval);
    //     slots.push({ start, end });
    //   }
    //   return slots;
    //
    // },
    getOfficeTimezone() {
      return this.loadedData.officesData[this.searchData.officeId]['timeZone']
    },
    currentTimeStamp(){
      // текущее время с учетом timezone
      const timeZone = String(this.getOfficeTimezone); // Часовой пояс
      const [hours, minutes] = timeZone.split(":").map(Number);
      const offsetMinutes = hours * 60 + (hours < 0 ? -minutes : minutes); // Минуты смещения

      const now = new Date();
      const utcTimestamp = now.getTime() + now.getTimezoneOffset() * 60 * 1000; // Метка времени в UTC
      let datenowStamp = utcTimestamp + offsetMinutes * 60 * 1000; // Учёт часового пояса
      return datenowStamp
    }
  },
  methods: {
    isCountData(cabinet_id){
      return cabinet_id in this.cabinetMatrix && Object.keys(this.cabinetMatrix[cabinet_id]).length > 0
    },
    resetSelect(){

      this.selectMoveIds = []
      this.selectedIds = []
      this.hideOverSelection()
      this.btnDisabled = true
      this.searchOn = false
    },
    hideSelectMove(id){
      return (this.selectMoveIds.length && !this.selectMoveIds.includes(id)) ||  (!this.selectMoveIds.length && this.isDisabledSelCabinet(id))
    },
    // showCabinet(cabId){
    //   if(this.selectMoveIds.length){
    //     let id = this.selectMoveIds[0].split("_")[0]
    //     return id == cabId
    //   }
    //   return true;
    //
    // },
    selectMove(id) {
      if (!this.selectMoveIds.length && this.isDisabledSelCabinet(id)) {
        return;
      }

      if (this.selectMoveIds.length) {
        if (!this.selectMoveIds.includes(id)) {
          return;
        }

        this.selectMoveIds = [];
        this.btnDisabled = true;
        return;
      }

      const countSelect = this.selectedIds.length;
      const cabinetId = id.split("_")[0];
      const fullMinute = Number(id.split("_")[1]);
      const start = fullMinute;

      this.selectMoveIds = [];

      for (let key = start; key <= start + (30 * (countSelect - 1)); key += 30) {
        this.selectMoveIds.push(cabinetId + '_' + key);
      }

      this.btnDisabled = false;
    },
    // selectMove(id){
    //   this.btnDisabled = true
    //   if((!this.selectMoveIds.length && this.isDisabledSelCabinet(id))){
    //     return
    //   }
    //   if(this.selectMoveIds.length){
    //     if(!this.selectMoveIds.includes(id)){
    //       return;
    //     }
    //     this.selectMoveIds = []
    //     // this.selectMoveIds = this.selectMoveIds.filter(item => item !== id);
    //   }else{
    //
    //     let countSelect = this.selectedIds.length
    //     let cabinetId = id.split("_")[0]
    //     let fullMinute = id.split("_")[1]
    //     let start = Number(fullMinute)
    //     for (let key = start; key <= start + (30 * (countSelect - 1 ) ); key += 30) {
    //       this.selectMoveIds.push(cabinetId+'_'+key)
    //     }
    //     this.btnDisabled = false
    //     // this.selectMoveIds.push(id)
    //
    //   }
    // },
    formatTime(minutes) {
      const hours = Math.floor(minutes / 60);
      const mins = minutes % 60;
      return `${hours}:${mins.toString().padStart(2, '0')}`;
    },
    outOfDate(time){
      let hour = time.split(":")[0]
      let minute = time.split(":")[1]
      hour = hour < 10 ? '0' + hour : hour;
      let brickTimeIso = this.date + 'T' + hour + ':' + minute + ':00';
      let brickStamp = new Date(brickTimeIso).getTime()
      return brickStamp < this.currentTimeStamp
    },
    buildMatrixCabinets(){

      let
          // cabinetsInfo = this.loadedData['cabinetsData']['cabinetsInfo'][this.cabinetData.office_id]
          cabinetsPrices = this.loadedData['cabinetsData']['cabinetsPrices'][this.cabinetData.office_id]
          ,officesData = this.loadedData['officesData'][this.cabinetData.office_id]
          ,workTimeEnd = officesData['workTimeEnd']
          ,workTimeStart = officesData['workTimeStart']
          ,workTimeStartHour = Number(workTimeStart.split(':')[0])
          ,workTimeStartMinute = Number(workTimeStart.split(':')[1])
          ,workTimeEndHour = Number(workTimeEnd.split(':')[0])
          ,workTimeEndMinute = Number(workTimeEnd.split(':')[1])
          ,workTimeStartFullTime = workTimeStartHour * 60 + workTimeStartMinute
          ,workTimeEndFullTime = workTimeEndHour * 60 + workTimeEndMinute


          // ,slost = this.timeLineData
      // console.log(this.loadedData);
      // console.log(officesData,workTimeStart, workTimeEnd);
      // console.log(workTimeStartHour,workTimeStartMinute, workTimeEndHour, workTimeEndMinute);
      // console.log(workTimeStartFullTime,workTimeEndFullTime);

      let bookingsData = this.loadedData['bookingsData'];
      // console.log(bookingsData) // isOwner
      for (var cabId in cabinetsPrices){
        let cabData = cabinetsPrices[cabId]
          for (var indx in cabData){
            let pricedata = cabData[indx]
            let hour = Number(pricedata['hour'])
                , interval = 30
                ,minuteStr = pricedata['minute'] == '1/2' ? '00': '30'
                ,minute = Number(minuteStr)
                ,fullTime = hour * 60 + minute
                ,timeStart = this.formatTime(fullTime)
                ,timeEnd = this.formatTime(fullTime + interval)
                ,outOfDate = this.outOfDate(timeStart)
                ,isBusy = false
                ,isPrevOwner = false
                ,isNextOwner = false
                ,isWorkTime = fullTime >= workTimeStartFullTime && fullTime < workTimeEndFullTime

            let minuteCode = minute == 0 ? '1/2':'2/2'
            let prevHour = minuteCode == '1/2' ? (hour > 0 ? hour - 1 : 23) : hour;
            let nextHour = minuteCode == '2/2' ? (hour < 23 ? hour + 1 : 0) : hour;
            let prevNextMinute = minuteCode == '1/2' ? '2/2' : '1/2';

            let cabTrue = false;
            if(this.cabinetData.office_id in bookingsData && cabId in bookingsData[this.cabinetData.office_id]){
              cabTrue = true;
            }
            // проверяем был ли предыдущий слот своей бронью
            if(cabTrue && prevHour in bookingsData[this.cabinetData.office_id][cabId] && prevNextMinute in bookingsData[this.cabinetData.office_id][cabId][prevHour] && bookingsData[this.cabinetData.office_id][cabId][prevHour][prevNextMinute]['isOwner']){
              isPrevOwner = true
              // console.log('isPrevOwner',cabId,prevHour,prevNextMinute,'-',hour,minuteCode)
            }

            // проверяем был ли следующий слот своей бронью
            if(cabTrue && nextHour in bookingsData[this.cabinetData.office_id][cabId] && prevNextMinute in bookingsData[this.cabinetData.office_id][cabId][nextHour] && bookingsData[this.cabinetData.office_id][cabId][nextHour][prevNextMinute]['isOwner']){
              isNextOwner = true
            }


            if (this.cabinetData.office_id in bookingsData){ // если есть данные по броням центра
              if (cabId in bookingsData[this.cabinetData.office_id]){ // если есть данные о бронях текущего кабинета

                if (hour in bookingsData[this.cabinetData.office_id][cabId]){// если есть данные о бронях на текущий час

                  if (minuteCode in bookingsData[this.cabinetData.office_id][cabId][hour]){// если есть данные о бронях на текущий слот мин
                    isBusy = true
                  }
                }
              }
            }


            if(!outOfDate && !isBusy && isWorkTime){ // если время не истекло и не занято и во временном диапазоне графика работы

              if (!(cabId in this.cabinetMatrix)){
                this.cabinetMatrix[cabId] = {}
              }
              if (!(fullTime in this.cabinetMatrix[cabId])){
                this.cabinetMatrix[cabId][fullTime] = {}
              }

              this.cabinetMatrix[cabId][fullTime] = {
                'cancelTime': pricedata['cancelTime'],
                'hour': pricedata['hour'],
                'minute': pricedata['minute'],
                'price': pricedata['price'],
                'type': pricedata['type'],
                'fullTime': fullTime,
                'minuteStr': minuteStr,
                'timeStart': timeStart,
                'timeEnd': timeEnd,
                'outOfDate': outOfDate,
                'date': this.date,
                'isBusy': isBusy,
                'isPrevOwner': isPrevOwner,
                'isNextOwner': isNextOwner,
                'id': cabId + '_'+fullTime,
              }
            }

          }
      }
      // console.log(this.cabinetMatrix)
      // console.log(this.cabinetMatrix);
      // Object.values(slost).forEach(sloatVal => {
      //   let
      //       stTime = sloatVal['start']
      //       ,hour = Number(stTime.split(":")[0])
      //       ,minute = Number(stTime.split(":")[1])
      //
      //   let fullTime = hour * 60 + minute;
      //   sloatVal['fullTime'] = fullTime
      //
      // });
      // console.log(slost);



    },
    getOfficeData(){
      // let _this = this;
      API.get(this.URL_GET, this.searchData).then(({data}) => {
        if (data.isOK) {
          // console.log(this.memoryData)
          // if ('officeSelectData' in this.memoryData['officeSelectData']){
          // _this.$store.dispatch('selector/resetSelector')
          // }

          // _this.$store.commit('setLoading', false, {root: true});

          // _this.$store.dispatch('setData', data.result);
          // this.searchData.officeId = data.result.currentOfficeId;
          // if('user' in data.result && 'defaultOffice' in data.result.user && data.result.user.defaultOffice > 0 ){
          //   console.log(data.result.user.defaultOffice)
          //   this.$store.dispatch('setOfficeCurrent', data.result.user.defaultOffice);
          //   this.searchData.officeId = data.result.user.defaultOffice;
          // }
          this.loading = false
          this.loadedData = data.result
          this.workTimeStart = this.loadedData.officesData[this.searchData.officeId]['workTimeStart'];
          this.workTimeEnd = this.loadedData.officesData[this.searchData.officeId]['workTimeEnd'];
          // this.buildMatrixCabinets()
          // this.checkedEmailNotify = data.result.user.notifyEmail ? true : false;
          // this.checkedTelegramNotify = data.result.user.notifyTelegram ? true : false;
          // this.telegramNotifyConnect = data.result.user.telegramNotifyConnect ? true : false;
          // this.telegramBotConnectUrl = data.result.user.telegramBotConnectUrl;

          // console.log(data.result);
        } else {
          console.error("Error:", data.errors)
          // _this.$store.commit('setLoading', false, {root: true});
        }
      }).catch((err) => {
        // _this.$store.commit('setLoading', false, {root: true});
        API.catch(err)
      })
    },
    setTimeViewTotalMinutes(val) {
      lastViewTotalMinutes = val
    },
    setTimeViewTotalMinutesCabinet(val) {
      lastViewTotalMinutesCabinet = val
    },
    setTimeViewTotalMinutesCabinetReset() {
      lastViewTotalMinutesCabinet = -1
    },
    isViewGap(currentMinutes) {
      return lastViewTotalMinutes + 30 != currentMinutes
    },
    isViewGapCabinet(currentMinutes) {
      return lastViewTotalMinutesCabinet >=0 && lastViewTotalMinutesCabinet + 30 != currentMinutes
    },
    isErrorBlock(id) {
      return this.errorBlock.includes(id) ? 'error-block' : ''
    },
    biuldMatrix() {
      // console.log(this.bookingData)
      const minuteToNumber = (m) => (m === "1/2" ? 0 : 30);
      let b_link = {}
      for (const key in this.bookingData) {

        let b = this.bookingData[key]

        b['totalMinutes'] = b.hour * 60 + minuteToNumber(b.minute)
        if(b['canCancel']){
          this.bookingMatrix.push(b)
          this.bookingLinkIdToMinutes[b.id] = b['totalMinutes']
          b_link[b['totalMinutes']] = b.id
        }
      }
      const timeLine = {};
      for (let minutes = 0; minutes < 1440; minutes += 30) {
        timeLine[minutes] = minutes in b_link ? b_link[minutes] : false
      }
      this.timeLineIndex = timeLine
    },
    handleSelection2(id){
      // console.log(this.changeSelectedIds)
      if(this.currentBookingId){
        this.selectedLinkIds[this.currentBookingId] = id
        for (let checkBoxId in this.disabledCheckboxes){
          this.disabledCheckboxes[checkBoxId] = false;
        }

      }

      // console.log(this.selectedLinkIds)
    },
    handleSelection() {
      this.selectMoveIds=[]
      // console.log(id)
      // console.log(this.bookingMatrix)
      // console.log(this.selectedIds)
      this.hideOverSelection()

      // this.tmpBlockSelection(id)
      // Проверяем правила отмены
      const {isValid, violations} = this.checkCancellationRules();
      if (!isValid) {
        this.searchOn = false
        this.validationMessage = violations
        this.btnDisabled = true
      } else {

        if(this.selectedIds.length){
          this.searchCabinets()
        }

        this.validationMessage = []
        if(this.selectedIds.length){
          // this.btnDisabled = false
          this.searchOn = true

        }else{
          this.searchOn = false
          this.btnDisabled = true
        }
      }


    },
    hideOverSelection(){// отключение диапазона бронирования вне выбранного диапазона

       if(this.selectedIds.length) {
         // группируем на диапазны
         const sorted = [...this.bookingMatrix].sort((a, b) => a.totalMinutes - b.totalMinutes);
         const grouped = [];
         let currentGroup = [sorted[0]];

         for (let i = 1; i < sorted.length; i++) {
           const prev = sorted[i - 1];
           const current = sorted[i];

           // Разница времени в секундах
           const diff = current.totalMinutes - prev.totalMinutes;

           if (diff <= 30) { // 30 минут
             currentGroup.push(current);
           } else {
             grouped.push(currentGroup);
             currentGroup = [current];
           }
         }

         if (currentGroup.length) {
           grouped.push(currentGroup);
         }

         // Оставляем только id
         let groupedIds = grouped.map(group => group.map(item => item.id));

         // let idsToDisable = [];
         this.disabledCheckboxesSelect = []
         groupedIds.forEach(group => {
           // Проверяем, есть ли выбранные id в диапазоне
           const hasSelected = group.some(id => this.selectedIds.includes(id));

           // Если в диапазоне нет выбранных id, добавляем все его id в массив
           if (!hasSelected) {
             this.disabledCheckboxesSelect.push(...group);
           }
         });

       }else{
         //сбрасываем disabled
         this.disabledCheckboxesSelect = []
       }

    },
    isDisabledSelCabinet(slotId){
      let cabId = slotId.split("_")[0]
      let id = slotId.split("_")[1]
      if(!(cabId in this.disabledCheckboxes)){
        return false
      }
      return  this.disabledCheckboxes[cabId][id]
    },
    searchCabinets(){

      // console.log('searchCabinets')
      this.buildMatrixCabinets()

      // смотрим какие ячейки подходят для бронирования
      let countSelect = this.selectedIds.length
      let interval = 30
      if (countSelect == 1){
        // фильтрация под правило переноса одной ячейки
        Object.keys(this.cabinetMatrix).forEach(cabId => {
          let badItems = []
          this.disabledCheckboxes[cabId] = {}
          //////
          // const snapshot = structuredClone(this.cabinetMatrix);
          // console.log(snapshot);
          ///////////////
          Object.keys(this.cabinetMatrix[cabId]).forEach(fullMinute => {


            let prev = Number(fullMinute) - interval
            let next = Number(fullMinute) + interval

                // ,isPrevOwner = false
                // ,isNextOwner = false
            let isOwnerPrev = (fullMinute in this.cabinetMatrix[cabId]) && ('isPrevOwner' in this.cabinetMatrix[cabId][fullMinute]) ? this.cabinetMatrix[cabId][fullMinute]['isPrevOwner'] :false;
            let isOwnerNext = (fullMinute in this.cabinetMatrix[cabId]) && ('isNextOwner' in this.cabinetMatrix[cabId][fullMinute]) ? this.cabinetMatrix[cabId][fullMinute]['isNextOwner'] :false;
            // console.log(isOwnerPrev,isOwnerNext, this.cabinetMatrix[cabId][fullMinute],cabId,fullMinute)

            // if(((prev in this.cabinetMatrix[cabId]) || (next in this.cabinetMatrix[cabId]))){
            //     badItems.push(fullMinute)
            // }

            let isMe = isOwnerPrev || isOwnerNext;

            // if(!isMe ){
            //   badItems.push(fullMinute)
            // }

            if(!isMe && ((prev in this.cabinetMatrix[cabId]) || (next in this.cabinetMatrix[cabId]))){
               badItems.push(fullMinute)
            }

          })
          if(badItems.length){
            for (let i in badItems){
              delete this.cabinetMatrix[cabId][badItems[i]]
            }
          }
        })



      }else{
      // фильтрация под правило переноса нескольких ячеек
      Object.keys(this.cabinetMatrix).forEach(cabId => {
        let good = [];
        Object.keys(this.cabinetMatrix[cabId]).forEach(fullMinute => {
          let start = Number(fullMinute)
          let tmpGood = []
          let isGood = true

          for (let key = start; key <= start + (30 * (countSelect - 1 ) ); key += 30) {
              tmpGood.push(key)
              if(!(key in this.cabinetMatrix[cabId])){
                isGood = false
              }
          }

          if(isGood){
            good = [...new Set([...good, ...tmpGood])];
          }else if(!good.includes(Number(fullMinute))){
            delete this.cabinetMatrix[cabId][fullMinute]
          }

          if(!(cabId in this.disabledCheckboxes)){
            this.disabledCheckboxes[cabId] = {}
          }
          if(isGood){
            this.disabledCheckboxes[cabId][fullMinute] = false
          }else{
            this.disabledCheckboxes[cabId][fullMinute] = true
          }

        });
      });

      }
    },

    checkCancellationRules() {
      const violations = []
      const selected = []
      var error1 = false
      var error2 = false
      this.errorBlock = []
      for (let i = 0; i < this.selectedIds.length; i++) {
        const selectedBookingId = this.selectedIds[i];
        if (selectedBookingId in this.bookingLinkIdToMinutes) {
          selected.push(this.bookingLinkIdToMinutes[selectedBookingId])
        }
      }

      for (let timeline in this.timeLineIndex) {
        let tl = Number(timeline)
        let prevIndex = tl == 0 ? 1440 : tl - 30
        let prevPrevIndex = tl == 0 ? 1440 - 30 : tl > 30 ? tl - 60 : 1440
        let nextIndex = tl == 1440 ? 0 : tl + 30
        let nextNextIndex = tl == 1440 ? 30 : tl + 60

        let prevBooking = selected.includes(prevIndex) ? false : this.timeLineIndex[prevIndex]
        let prevPrevBooking = selected.includes(prevPrevIndex) ? false : this.timeLineIndex[prevPrevIndex]
        let currentBooking = selected.includes(tl) ? false : this.timeLineIndex[tl]
        let currentBookingId = this.timeLineIndex[tl]
        let nextBooking = selected.includes(nextIndex) ? false : this.timeLineIndex[nextIndex]
        let nextNextBooking = selected.includes(nextNextIndex) ? false : this.timeLineIndex[nextNextIndex]

        if(selected.length && !this.disabledCheckboxesSelect.includes(currentBookingId)) {
          if (!prevPrevBooking && !prevBooking && currentBooking && !nextBooking && !nextNextBooking) {
            this.errorBlock.push(currentBooking)
            if (!error1) {
              violations.push(
                  `Нельзя оставлять 1 бронь в 30 минут.`
              );
              error1 = true
            }
          }

          if (prevBooking && !currentBooking && nextBooking) {
            this.errorBlock.push(currentBookingId)
            if (!error2) {
              violations.push(
                  `Нельзя оставлять  промежуток  в 30 минут между бронями.`
              );
              error2 = true
            }
          }
        }
      }
      return {isValid: violations.length === 0, violations};
    },
    timeView(data) {
      return 'c ' + this.timeView1(data) + ' до ' + this.timeView2(data);
    },
    timeView1(data) {
      return data.hour + ':' + data.minuteView;
    },
    timeView2(data) {
      let hour = data.minuteView == '30' ? data.hour + 1 : data.hour;
      let minute = data.minuteView == '30' ? '00' : '30';
      return hour + ':' + minute;
    },
    closeCmodal() {
      closeModal();
    },
    moveBooking() {

      // console.log(this.selectedIds)
      let idCode = this.selectMoveIds[0]
      let cabId = Number(idCode.split("_")[0])
      let fullMinute = Number(idCode.split("_")[1])
      let hour = Math.floor(fullMinute / 60);
      let minute = fullMinute % 60;

      // console.log(cabId,hour,minute)

      // URL_MOVE_BOOKING
      this.btnDisabled = true
      this.loaderShow = true

      API.get(this.URL_CHANGE_BOOKINGS, {
        bookingIds: this.selectedIds,
        cabinetId: cabId,
        hour: hour,
        minute: minute
      }).then(({data}) => {
        console.log(data)
        if (data.isOk) {

          this.toast.info("Перенос бронирования прошел успешно.");
          // this.$emitter.emit('ChangeBookingsDone',this.selectedIds)
          this.$router.replace({ name: 'mybookings' });
          setTimeout(()=>location.reload(true), 2000)


          // this.$emitter.emit('mybookingCancelDone',this.selectedIds)

        } else {
          this.toast.error('Ошибка переноса бронирования.'+"\n" + data.errors.message);
          console.error("Error:", data.errors)
          this.$router.replace({ name: 'mybookings' });
        }
      }).catch((err) => {
        API.catch(err)
      }).finally(() => {
        this.loaderShow = false
        this.btnDisabled = true
        this.resetSelect()
        closeModal();
      })

    }
  }
}
</script>
<style scoped>


.fake-checkbox{
  border-radius: .25em;
  border: 1px solid #c1c1c1;
  display: inline-block;
  width: 1em;
  height: 1em;
  vertical-align: top;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0, 0, 0, .25);
}

.fake-checkbox.checked{
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e");
  width: 1em;
  height: 1em;
  //background-color: #0d6efd;
  background-color: #25b100;
  //border-color: #0d6efd;
  border-color: #25b100;
}
.hide{
  opacity: 0;
}




.price-lbl{
  text-align: center;
  font-size: 0.770rem;
  color: #c77620;
}

.error-msg-block {
  font-size: 0.9rem;
  color: #c13535;
  min-height: 3rem;
}

.restest {
  font-size: 0.9rem;
  height: 100%;
}

.h-100 {
  height: 100%;
}

.form-check {
  padding: 0;
}

.form-check .form-check-input {
  margin-left: 0;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.change-wrap {
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
}

.add-btn-wrap {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.add-comment-btn {
  font-size: 0.7em;
  border: none;
  padding: 0.4em 1em;
  border-radius: 1em;
  background: #dd9f4c57;
  color: #704a00;
  line-height: 1.35em;
  border: 1px solid #fff;
  box-shadow: inset 0px 0px 0px 1px #34343417;
  /*text-shadow: 0px 1px 0px #fff;*/
  transition: all ease .3s;
}

.add-comment-btn:hover {
  background: #dd9f4c77;
}

.list-modal {
  //width: 460px;
  width: 95vw;

  max-width: 1024px;
  max-height: 100vh;
  container-name: list-modal-container;
  container-type: inline-size;
}

.list-modal .card-body {
  padding: 0;
  overflow: auto;
  height: 400px;
  height: auto;
  max-height: 70vh;
}

@container list-modal-container {
  .list-modal .card-body {
    height: 80cqh;
  }
}

.hourBlock {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 4em;
  width: 4.2em;
  min-width: 4.2em;
  border: 1px solid #c7bbbb7a;
  padding: 0.1rem 0.1rem;
  border-radius: 5px;
  font-size: .7em;
  line-height: 1em;
  align-items: center;
  color: #fff;
  background: #81b29a;
  justify-content: center;
  border: 1px solid #17573800;
  box-shadow: -4px 6px 10px 0px #211e1e40;
  user-select: none;
}

.block {
  display: block;
}

.mycomment {
  font-size: .85em;
}

.mycomment.adm {
  color: #782f36;
}

.label {
  font-size: 0.65em;
  color: #9f9f9f;
}

.label.adm {
//font-size: 0.65em; //color: #c15761;
}

.block-line {

  padding: 0.2em;

}

.block-line * {
  cursor: pointer;
}

.block-line:nth-of-type(2n) {
  background: #fff8db59;
}

.error-block {
  background: #b99595;
}

.block-gap {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding-top: 1rem;
}
.block-gap.cabinet{
  padding-top: 0rem;
}

.card-line{
  border-bottom: 1px solid #ccc;
}
</style>